import { cloneDeep } from 'lodash';

export default {
	audit: state => cloneDeep(state.oneAudit),
	personWithAudit: state => cloneDeep(state.personWithAudit),
};
